import gsap from "gsap";

const intiAni = gsap.timeline({paused:true})
    .addLabel('start')
    .from('.liveserver__bg', 7, {scale:1.5, ease:"Power1.easeOut"},"start")
    .from('.liveserver__title', 0.9, {y:120, autoAlpha:0, ease:"Power1.easeOut"}, "start+=0.5")
    .from('.liveserver__txt', 0.9, {y:120, autoAlpha:0, ease:"Power1.easeOut"}, "start+=0.7")
    .staggerFrom('.liveserver__left dd', 0.6, {x:-120,opacity:0,ease: "Power1.easeOut",}, 0.2, 'start+=1.5')
    .from('.liveserver__left i', 0.9, {width:0, autoAlpha:0, ease:"Power1.easeOut"}, "start+=2.0")
    .from('.liveserver__left dt', 0.9, {x:-80, autoAlpha:0, ease:"Power1.easeOut"}, "start+=2.8")

    .staggerFrom('.liveserver__right dd', 0.6, {x:120, opacity:0,ease: "Power1.easeOut",}, 0.2, 'start+=3.5')
    .from('.liveserver__right i', 0.9, {x: 80, width:0, autoAlpha:0, ease:"Power1.easeOut"}, "start+=4.0")
    .from('.liveserver__right dt', 0.9, {x:80, autoAlpha:0, ease:"Power1.easeOut"}, "start+=4.8")

export default {
    id: '#liveserver',
    name: '라이브 서버 통합',
    enterStart() {
        intiAni.seek(0);
        intiAni.play();
    },
    enterEnd(){

    },
    leaveStart() {

    },
    leaveEnd(){
    }
};



// WEBPACK FOOTER //
// ./src/js/page/liveserver.js